export default {"src":"/_next/static/media/chains-own.2531088c.svg","height":100,"width":100};